/**
 * Learner flavor — site discovery / DOM inspection via client tools.
 *
 * Registers: inspectPage, queryDOM, startNetworkCapture, stopNetworkCapture
 */
import { BaseFlavor } from './BaseFlavor.js';
import {
  inspectPage,
  queryDOM,
  startNetworkCapture,
  stopNetworkCapture,
} from './learnerTools.js';

/** Minimal manager — learner UX does not surface product/room cards. */
class LearnerManager {
  handleShowItems(/* msg */) {}

  handleCartUpdated(/* msg */) {}

  hideLearnerUI() {}
}

class LearnerFlavor extends BaseFlavor {
  createManager(/* { shadowRoot, primaryColor } */) {
    return new LearnerManager();
  }

  getManagerHideMethod() {
    return 'hideLearnerUI';
  }

  buildTools() {
    return [
      { name: 'inspectPage', handler: async () => inspectPage() },
      {
        name: 'queryDOM',
        handler: async (params) => {
          const options =
            params?.options && typeof params.options === 'object' && !Array.isArray(params.options)
              ? params.options
              : {
                  mode: params?.mode,
                  limit: params?.limit,
                  depth: params?.depth,
                };
          return queryDOM(params?.selector, options);
        },
      },
      { name: 'startNetworkCapture', handler: async () => startNetworkCapture() },
      { name: 'stopNetworkCapture', handler: async () => stopNetworkCapture() },
    ];
  }

  destroy() {
    stopNetworkCapture();
    super.destroy();
  }
}

export function createLearnerFlavor(widget, flavor = {}) {
  return new LearnerFlavor(widget, flavor);
}
